// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'

export default {
  MenuMagazine: codeSplit({
    l10n: {},
    loadComponent: () =>
      import(
        /* webpackChunkName: "MenuMagazine" */
        './index'
      ),
  }),
}
